import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	done: {
		id: 'card.common.flag.done',
		defaultMessage: 'Flagged',
		description: 'Tooltip around an icon indicating whether an issue is flagged',
	},
});
